import React, { useCallback, useEffect, useState } from "react";
import { getImgUrlById } from '../../util'

import GSTC from "gantt-schedule-timeline-calendar/dist/gstc.wasm.esm.min.js";
import { Plugin as TimelinePointer } from "gantt-schedule-timeline-calendar/dist/plugins/timeline-pointer.esm.min.js";
import { Plugin as Selection } from "gantt-schedule-timeline-calendar/dist/plugins/selection.esm.min.js";
import { Plugin as ItemResizing } from "gantt-schedule-timeline-calendar/dist/plugins/item-resizing.esm.min.js";
import { Plugin as ItemMovement } from "gantt-schedule-timeline-calendar/dist/plugins/item-movement.esm.min.js";
import user_default from '../../static/image/user_default.png'
import { Plugin as TimeBookmarks } from "gantt-schedule-timeline-calendar/dist/plugins/time-bookmarks.esm.min.js";
import { Tooltip } from 'antd'
import { Modal } from 'antd'
const { confirm } = Modal;
let gstc: any;
let state: any;

// helper functions
interface Props {
  data?: any
}



const GanttSchedule = (props: Props) => {
  const [taskVisible, setTaskVisible] = useState<boolean>(false);

  useEffect(() => {
    return () => {
      console.log('gstc',gstc)
      // if (gstc) {
      //   gstc.destroy();
      // }
    };
  });
  function rowSlot(vido: any, props: any) {
    const { html, onChange, update, api } = vido;
    let img = '';
    onChange((newProps: any) => {
      props = newProps;
      if (!props || !props.row) return;
      img = props.row.img;
      update();
    });

    return (content: any) => {
      if (!props || !props.column) return content;
      return api.sourceID(props.column.id) === 'label'
        ? html`<img class="item-image" style="flex-shrink:0;border-radius:100%;width:24px;height:24px;vertical-align: middle;background-size: 100%;margin-right:10px" alt=""  src=${(img) ? getImgUrlById(img) : user_default}  
        />`
        : content;
    };
  }
  function getRandomColor(item: any) {
    console.log(item)
    let bg = ''
    switch (item) {
      case '任务计划':
        bg = 'linear-gradient(90deg, #5591EE 0%, #407FE3 100%)'
        break;
      case '开始执行':
        bg = 'linear-gradient(90deg, #FFB139 0%, #ED9F29 100%)'
        break;
      case '任务完成':
        bg = 'linear-gradient(90deg, #1EC318 0%, #15AA10 100%)'
        break;
      case '版本计划':
        bg = 'linear-gradient(91deg, #A791EF 0%, #8874D9 100%)'
        break;
    }
    return bg;
  }
  function generateRows() {
    /**
     * @type { import("gantt-schedule-timeline-calendar").Rows }
     */
    const rows = {};
    console.log('data', props.data)
    //rowId要对应上
    for (let i = 0; i < props.data.length; i++) {
      const id = GSTC.api.GSTCID(i.toString());
      rows[id] = {
        id,
        label: `${props.data[i].newestExecutorUser?.username}`,
        content: `${props.data[i].content}`,
        img: props.data[i].newestExecutorUser?.avatar,
      };
    }
    console.log(rows)
    return rows;
  }

  function generateItems() {
    /**
     * @type { import("gantt-schedule-timeline-calendar").Items }
     */
    const items = {};
    // @ts-ignore
    let start = GSTC.api.date().startOf("day").subtract(6, "day");
    console.log()
    props.data.map((i: any, index: any) => {
      const id = GSTC.api.GSTCID(i.id.toString());
      const rowId = GSTC.api.GSTCID(index);
      start = start.add(1, "day");
      let info: any = i.taskTagList[0]
      items[id] = {
        id,
        label: `${JSON.stringify(i)}`,
        rowId,
        img: i.newestExecutorUser?.avatar,
        // img: '../../static/image/baidu.png',
        // header: {
        //   html: '<div class="my-header-class">My header label</div>',
        // },
        // classNames: ['additional-custom-class'],
        // description: 'Lorem ipsum dolor sit amet',
        style: { background: getRandomColor(i.taskTagList[i.taskTagList.length-1].name) },
        time: {
          start: new Date(i.taskTagList[i.taskTagList.length-1].startTime).valueOf(),
          end: new Date(i.taskTagList[i.taskTagList.length-1].finishTime).valueOf(),
        },
      };
    })
    console.log(items)
    return items;
  }
  function itemSlot(vido: any, props: any) {
    const { html, onChange, update } = vido;
    console.log('html',vido)

    let imageSrc = '';
    let description = '';
    onChange((newProps: any) => {
      props = newProps;
      if (!props || !props.item) return;
      imageSrc = props.item.img;
      description = props.item.description;
      update();
    });
    return (content: any) =>(
      html`<div>
        <img class="item-image " style="flex-shrink:0;border-radius:100%;width:24px;height:24px;vertical-align: middle;background-size: 100%;margin-right:10px" alt=""  src=${(imageSrc) ? getImgUrlById(imageSrc) : user_default}  
         /></div>
        <div class="item-text">
          <div class="item-label">${JSON.parse(content).content}</div>
          <div class="item-label">11</>
          <div class="item-description" style="font-size:11px;margin-top:2px;color:#fffffff0;line-height:1em;">
            ${description}
          </div>
        </div>`);
  }
  function taskInfo(info: any) {
    confirm({
      icon: <></>,
      content: <div>
        <img alt="" src={info.img}
        />{JSON.parse(info.label).content}</div>,
      okText: '确认',
      cancelText: '取消',
      onOk() {
        console.log('确认');
      },
      onCancel() {
        console.log('取消');
      },
    });
  }
  function myItemSlot(vido: any, props: any) {
    const { onChange } = vido;

    function onClick() {
      console.log('Item click from slot', props.item);
      taskInfo(props.item)
    }

    onChange((changedProps: any) => {
      // if current element is reused to display other item data just update your data so when you click you will display right alert
      // props = changedProps;
    });

    // return render function
    return (content: any) =>
      vido.html`<div class="my-item-wrapper" @click=${onClick} style="width:100%;display:flex;overflow:hidden;pointer-events:none;">${content}</div>`;
  }
  function initializeGSTC(element: any) {
    console.log('initializeGSTC', element)
    /**
     * @type { import("gantt-schedule-timeline-calendar").Config }
     */
    console.log('lll', new Date().valueOf())
    let bookmarks: any = {
      id: 'bookmarks1',
      time: new Date().valueOf(),
      label: '当前日期',
      style: {
        background: 'red',
      },
    };
    console.log(document.body.clientHeight )
    //配置获取licenseKey地址https://gstc.neuronet.io/free-key 
    const config = {
      licenseKey:
      "====BEGIN LICENSE KEY====\nThtEYNQVoeYfAygIROA+Dg2Zlu0p9Iv0cWgkXNOc0apOAkplziiw+F8U9qWhVyvhjv5K6Yf65/CHmLZqUVKWZLudb16ach37Ar6Rs6iPVib/vjq+vRK6GoIA3kl56el6fxXX0bGzd7vOUBtWL7LpnFah0bwCtxtaKeY3M3h7AdeEtbwQYvjUE232y+g9ni1LKu+PC66ByS2FNkPUQlXX0fLZH1TzLMmBb/pytbKVxx0cYYxrjK01j+5l77cZhaj0HCfYvzkaKoucWgQiB/RfuIiI/SpGmyZ1XmQB30/sZ0UCrvMB8Ubg802BNynkRtc12uuZ33F0HVOTeyModH4bKA==||U2FsdGVkX18ajxovzNIktEL663CBMQKl/x46xUsWlHMWc0CWk2GkmCBGTtowsCkgGxpC4e1nWyLvLGG+jV4LduEVuYQJe9RLZMmz+wziI1M=\nQkyS3FMTD1H945fK6xjcKwmxM+6lHLfvaLZJrV6A2rJ6ONRe4gaDTV36465Ehic8JRjetQjhvbnftAr2j78t94MDvplvwJk5rmG20mlGFXW+aDsLYZNsOcQ5VYP4IAQRUkddYaFttX1t8LhJbgH/rWJnqEOhmnH51XsTWPZ1le62sGUvZROw5SugQpubaq7jyvu51sCkmTefKylL7ybtW+I/hoJ/Xh7nBBUBeEkFuNE/05G0r9ExTJpxn9Wgb4/dBmRm3WRM4n59CA7rrGRI5XA7HgP3jMDpEHGBKkSvoRLfYNRmiT6Vy5AhrvvvJz8s+srnbJj/ayCXyn1PL2Fdfw==\n====END LICENSE KEY====",
      // plugins: [TimelinePointer(), Selection(), ItemResizing(), ItemMovement()],
      innerHeight: document.body.clientHeight -100,
      plugins: [TimelinePointer(), TimeBookmarks({ bookmarks, })],
      list: {
        columns: {
          data: {
            // [GSTC.api.GSTCID("id")]: {
            //   id: GSTC.api.GSTCID("id"),
            //   width: 60,
            //   data: ({ row }: { row: any }) => GSTC.api.sourceID(row.id),
            //   header: {
            //     content: "ID",
            //   },
            // },
            [GSTC.api.GSTCID("label")]: {
              id: GSTC.api.GSTCID("label"),
              data: 'label',
              sortable: 'label',
              expander: false,
              isHTML: false,
              width: 60,
              header: {
                content: '执行人',
              },
            },
            [GSTC.api.GSTCID("content")]: {
              id: GSTC.api.GSTCID("content"),
              data: 'content',
              sortable: 'content',
              expander: false,
              isHTML: false,
              width: 150,
              header: {
                content: '内容',
              },
            },
          },
        },
        rows: generateRows(),
      },
      chart: {
        items: generateItems(),
      },
      slots: {
        'chart-timeline-items-row-item': { content: [itemSlot], inner: [myItemSlot] },
        'list-column-row': { content: [rowSlot] },
        // 'chart-timeline-grid-row': { content: [myBirthdayRowSlot, myVacationRowSlot] },
      },
    };

    state = GSTC.api.stateFromConfig(config);

    gstc = GSTC({
      element,
      state,
    });
  }
  const callback = useCallback((element: any) => {
    console.log('GanttSchedule', element)
    if (element) initializeGSTC(element);
  }, []);



  function updateFirstRow() {
    state.update(`config.list.rows.${GSTC.api.GSTCID("0")}`, (row: any) => {
      row.label = "Changed dynamically";
      return row;
    });
  }

  function changeZoomLevel() {
    state.update("config.chart.time.zoom", 21);
  }

  return (
    <>
      <div className="toolbox">
        {/* <button onClick={updateFirstRow}>Update first row</button> */}
        {/* <button onClick={changeZoomLevel}>Change zoom level</button> */}
      </div>
      <div className="gstc-wrapper" ref={callback}>
        <Modal
          onCancel={() => {
            setTaskVisible(false)
          }}
          title={'详情'}
          width={'50%'}
          footer={null}
          // footer={[<Button className='btn' htmlType="submit"  key='btn' type="primary" onClick={() => {
          // }}>新建计划</Button>]}
          open={taskVisible}>
          <div>
            lllll
          </div>
        </Modal>
      </div>
    </>
  );
}

export default GanttSchedule;